import Vue from 'vue'
import VueRouter from 'vue-router'
import restApi from '../api/restapi'

const Home = () => import('@/views/Home');
const Login = () => import('@/views/Login');
const Customers = () => import('@/views/Customers');
const Chat = () => import('@/views/Chat');
const Conversations = () => import('@/views/Conversations');
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: Home,
        redirect: '/conversations',
        children: [
            {
                path: 'conversations',
                components: {
                    default: Conversations
                },
                children: [{
                    path: 'chat/:id',
                    components: {
                        default: Chat
                    }
                }]
            },
            {
                path: 'customers',
                components: {
                    default: Customers
                }
            }
        ]
    },
    {
        path: '/login',
        components: {
            default: Login
        }
    }
];

const router = new VueRouter({
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    if (to.path !== '/login' && !Vue.prototype.globalData.currentAgent) {
        // 支持URL参数免登录: ?agentId=xxx 或 ?username=xxx&password=xxx
        let agent = null;
        const query = to.query;
        if (query.agentId) {
            agent = restApi.findAgentById(query.agentId);
        } else if (query.username && query.password) {
            agent = restApi.findAgent(query.username, query.password);
        }
        if (agent) {
            agent.shop = restApi.findShopById(agent.shopId);
            Vue.prototype.globalData.currentAgent = agent;
            sessionStorage.setItem('currentAgent', JSON.stringify(agent));
            next();
        } else {
            next({path: '/login'});
        }
    } else next()
});

export default router
